import { z } from "zod";
import { BACKUP_CODE_LENGTH, OTP_LENGTH } from "@/config/auth.config";

export const loginSchema = z.object({
  email: z.string().min(1, "Email is required").email("Please enter a valid email address"),
  password: z.string().min(1, "Password is required"),
});

export type LoginFormData = z.infer<typeof loginSchema>;

export const forgotPasswordEmailSchema = z.object({
  email: z.string().min(1, "Email is required").email("Please enter a valid email address"),
});

export type ForgotPasswordEmailFormData = z.infer<typeof forgotPasswordEmailSchema>;

export const otpFormSchema = z.object({
  otp: z
    .string()
    .length(OTP_LENGTH, `Enter the ${OTP_LENGTH}-digit code from your authenticator.`)
    .regex(/^\d+$/, "Code must be digits only."),
});

export type OtpFormValues = z.infer<typeof otpFormSchema>;

export const backupCodeFormSchema = z.object({
  code: z
    .string()
    .length(BACKUP_CODE_LENGTH, `Enter a ${BACKUP_CODE_LENGTH}-digit backup code.`)
    .regex(/^\d+$/, "Backup code must be digits only."),
});

export type BackupCodeFormValues = z.infer<typeof backupCodeFormSchema>;
